// extracted by mini-css-extract-plugin
export var deleteModal = "_f8-0";